import {Component, inject} from '@angular/core';
import {AccessService} from '../../services/access';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header {

    accessService = inject(AccessService);

}
